
























// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'
import { v4 as uuid } from 'uuid'

import { DashmixButton } from '../../atoms/Button'
import { DashmixIcon } from '../../atoms/Icon'

import { DashmixDropdownDivider, DashmixDropdownItem } from './_partials'
import { DashmixDropdownProps } from './Dropdown.contracts'
import { dashmixDropdownProps, useDashmixDropdown } from './Dropdown.hooks'

/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const DashmixDropdown = defineComponent({
  name: 'Dropdown',
  components: { DashmixButton, DashmixDropdownDivider, DashmixDropdownItem, DashmixIcon },
  props: dashmixDropdownProps,

  setup (props: DashmixDropdownProps, ctx: SetupContext) {
    return { ...useDashmixDropdown(props, ctx), id: uuid() }
  }
})

export default DashmixDropdown
